//
// ===== File globals.ts    
//
'use strict';

export const name: string="Christian Anderser";
export const job: string="Escritor";
export const description: string="Hijo de un humilde zapatero, pronto aprendió diversos oficios, pero no finalizó ninguno. Con catorce años, huyó con poco dinero a Copenhague dispuesto a hacer fortuna como actor y cantante; malvivió, escribió algunas obras y después de privaciones y desengaños, consiguió despertar.";
export const about_description: string="además de novelas, poesía y teatro, escribió una autobiografía (La aventura de mi vida, 1855) y publicó valiosos libros de viajes fruto de sus experiencias, ya que se pasó aproximadamente diez años de su vida viajando."